"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lao = void 0;
var types_1 = require("../types");
exports.lao = {
    code: types_1.LocaleCode.Lao,
    facebook: 'lo_LA',
    label: 'ພາສາລາວ',
    loadingText: 'ກຳ ລັງໂຫລດ ...',
    translations: {
        ar: 'ພາສາອາຣາບິກ',
        de: 'ພາສາເຢຍລະມັນ',
        en: 'ພາສາອັງກິດ',
        es: 'ພາສາແອັສປາຍ',
        fr: 'ພາສາຝຣັ່ງ',
        id: 'ພາສາອິນໂດນີເຊຍ',
        it: 'ພາສາອີຕາລີ',
        ja: 'ພາສາຍີ່ປຸ່ນ',
        ko: 'ພາສາເກົາຫຼີ',
        lo: 'ພາສາລາວ',
        ms: 'ພາສາມາເລເຊຍ',
        pt: 'ພາສາປັອກຕຸຍການ',
        ru: 'ພາສາລັດເຊຍ',
        th: 'ພາສາໄທ',
        tl: 'ພາສາຟິລິບປິນ',
        tr: 'ພາສາຕວກກີ',
        vi: 'ພາສາຫວຽດນາມ',
        'zh-CN': '‪ພາສາຈີນ (ກາງ)‬',
        'zh-TW': '‪ພາສາຈີນ (ດັ້ງເດີມ)‬‬‬‬'
    }
};
